// extracted by mini-css-extract-plugin
export var callCard = "_sg-0";
export var callMessageButton = "_sg-1";
export var helpIcon = "_sg-3";
export var helpIconContainer = "_sg-4";
export var verticalDivider = "_sg-2";